import { render, staticRenderFns } from "./InformationreleaseTop.vue?vue&type=template&id=3d9b8d64&scoped=true&"
import script from "./InformationreleaseTop.vue?vue&type=script&lang=js&"
export * from "./InformationreleaseTop.vue?vue&type=script&lang=js&"
import style0 from "./InformationreleaseTop.vue?vue&type=style&index=0&id=3d9b8d64&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9b8d64",
  null
  
)

export default component.exports